import type { FC } from 'react';
import { cn } from '@ifixit/ui/lib/utils';

interface MenuIconProps {
   isActive: boolean;
   onClick: () => void;
}

const pathClass = 'fill-white transition-all duration-[250ms] group-hover:fill-gray-200';

const MenuIcon: FC<MenuIconProps> = ({ isActive = false, onClick = () => {} }) => (
   <button
      type="button"
      aria-label="Menu"
      onClick={onClick}
      id="menuIcon"
      className="group flex shrink-0 cursor-pointer touch-manipulation border-0 bg-transparent p-1.5"
   >
      <svg
         width="24"
         height="24"
         viewBox="0 0 24 24"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         focusable="false"
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 6C3 5.44772 3.40294 5 3.9 5H20.1C20.5971 5 21 5.44772 21 6C21 6.55228 20.5971 7 20.1 7H3.9C3.40294 7 3 6.55228 3 6Z"
            className={cn(pathClass, isActive && '[transform:rotate(45deg)_translate(6px,-8px)]')}
         />
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 12C3 11.4477 3.40294 11 3.9 11H20.1C20.5971 11 21 11.4477 21 12C21 12.5523 20.5971 13 20.1 13H3.9C3.40294 13 3 12.5523 3 12Z"
            className={cn(pathClass, isActive && 'opacity-0 [transform:translateX(-100%)]')}
         />
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 18C3 17.4477 3.40294 17 3.9 17H20.1C20.5971 17 21 17.4477 21 18C21 18.5523 20.5971 19 20.1 19H3.9C3.40294 19 3 18.5523 3 18Z"
            className={cn(pathClass, isActive && '[transform:rotate(-45deg)_translate(-10px,0)]')}
         />
      </svg>
   </button>
);

export default MenuIcon;
